import { Link, Taxonomies } from "@customTypes/index";
import { PresentationFields, Routes } from "@lib/constants";
import { Badge, Button, Col, Row, Space, Tag } from "antd";

interface BookshelfCtaProps {
  className: string;
  title: string | null;
  taxonomies: Taxonomies | null;
  flip: string | null;
  date: string | null;
  description: string | null;
  showFields: string[];
  link: Link;
  images: any;
  showNewBadge: boolean;
}

const defaultProps: BookshelfCtaProps = {
  className: "",
  title: null,
  taxonomies: null,
  date: null,
  flip: "start",
  description: "",
  showFields: [],
  showNewBadge: false,
  link: {
    url: "",
    name: "",
    target: "_self",
  },
  images: [],
};

const BookshelfCta = ({
  className,
  title,
  taxonomies,
  date,
  description,
  flip,
  link,
  images,
  showFields,
  showNewBadge
}: BookshelfCtaProps) => {

  const direction: any = flip === 'start' ? "row-reverse" : "";

  const books = images.map((item, index) => (
    <Col key={`${item?.url}-${index}`} flex="auto">
      <a target={link.target} href={link.url}>
        <img src={item?.url} alt={``} loading="lazy" />
      </a>
    </Col>
  ));

  return (
    <Row
      className={`covr-cta-bookshelf ${className}`}
      gutter={[16, 16]}
      align={`middle`}
      style={{
        flexDirection: direction,
      }}>
      <Col className="right" xs={24} sm={24} md={12} lg={12} xl={12}>
        {showNewBadge
          ? <Badge.Ribbon className={`corner-wedge-badge`} text="NEW" placement="end" color="yellow">
            <Row className={`books`} wrap={false}>
              {books}
            </Row>
          </Badge.Ribbon>
          :
          <Row className={`books`} wrap={false}>
            {books}
          </Row>}
      </Col>
      <Col className="left" xs={24} sm={24} md={12} lg={12} xl={12}>
        <Row className="h-100">
          <Col className="details" span={24}>
            {title
              && showFields?.includes(PresentationFields.TITLE)
              && <Row>
                <Col span={24}>
                  <a target={link.target} href={link.url}>
                    <h3>{title}</h3>
                  </a>
                </Col>
              </Row>
            }
            {date
              && showFields?.includes(PresentationFields.DATE)
              && <Row>
                <Col span={24}>
                  <a target={link.target} href={link.url}>
                    <h4>{date}</h4>
                  </a>
                </Col>
              </Row>
            }
            {description
              && showFields?.includes(PresentationFields.DESCRIPTION)
              && <Row>
                <Col span={24}>
                  <a target={link.target} href={link.url}>
                    <p>{description}</p>
                  </a>
                </Col>
              </Row>
            }
            <Row>
              {taxonomies?.category
                && showFields?.includes(PresentationFields.CATEGORY)
                && <Col span={24}>
                  <Space className={`mar-bot-5`} size={[5, 5]} wrap>
                    {taxonomies.category.map((cat) =>
                      <Tag key={cat.id} color={`${cat.color}`}>
                        <a href={`${Routes.COLLECTOR_CONTENT_SEARCH}/?terms=${cat.id}`}>
                          {cat.name}
                        </a>
                      </Tag>
                    )}
                  </Space>
                </Col>}
              {taxonomies?.tags
                && showFields?.includes(PresentationFields.TAGS)
                && <Col span={24}>
                  <Space className={`mar-bot-5`} size={[5, 5]} wrap>
                    {taxonomies.tags.map((tag) =>
                      <Tag key={tag.id} color={`${tag.color}`}>
                        <a href={`${Routes.COLLECTOR_CONTENT_SEARCH}/?terms=${tag.id}`}>
                          {tag.name}
                        </a>
                      </Tag>
                    )}
                  </Space>
                </Col>}
            </Row>
            {link.name
              && showFields?.includes(PresentationFields.LINK)
              && <Button target={link.target} href={link.url} type="link">
                {link.name}
              </Button>}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

BookshelfCta.defaultProps = defaultProps;

export default BookshelfCta;

